const moment = require("moment")
export const getDiffrenceOfTimeInMinutes = (etime: string) => {
    const time = moment(new Date())
    const et = moment(new Date(etime))
    return et.diff(time, "minutes")
}
export const externalRedirect=(url:any)=>{
    window.open(url);
}